/**
 * Curated palette of accent colors used for avatar backgrounds.
 *
 * Every entry has been picked to maintain WCAG AA contrast (~4.5:1) with white
 * text — antd's Avatar paints initials in `colorTextLightSolid` (white) by
 * default — so no pastel/light shades. Stick to mid-saturated 6XX/7XX hues.
 */
export const AVATAR_PALETTE = [
  '#0F766E', // teal (brand)
  '#2563EB', // blue
  '#4F46E5', // indigo
  '#7C3AED', // violet
  '#C026D3', // fuchsia
  '#DB2777', // pink
  '#DC2626', // red
  '#B45309', // amber-700
  '#059669', // emerald
  '#0891B2', // cyan-600
  '#475569', // slate
  '#0E7490', // cyan-700
  '#9333EA', // purple
  '#0F766E' // teal-700
] as const

const hash = (s: string): number => {
  let h = 5381
  for (let i = 0; i < s.length; i += 1) {
    // djb2: h * 33 + char, force unsigned 32-bit so consecutive seeds map to
    // different palette entries reliably.
    h = ((h << 5) + h + s.charCodeAt(i)) >>> 0
  }
  return h
}

/**
 * Deterministic palette pick for a person's avatar. Same seed always returns
 * the same color; different names spread across the palette uniformly.
 */
export const pickAvatarColor = (seed: string | null | undefined): string => {
  const s = (seed ?? '').trim()
  if (!s) return AVATAR_PALETTE[0]
  return AVATAR_PALETTE[hash(s) % AVATAR_PALETTE.length]
}
